var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cssload-container"},[_c('div',{staticClass:"cssload-double-torus",class:{'is_blue': _vm.isBlue}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }